<template>
	<div data-tour-scope="affiliate-partner">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation="0">
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Affiliate Partner</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
							<v-toolbar-items>
								<!-- una sola azione: il piu' porta dritto alla pagina, senza menu -->
								<v-btn text title="Nuovo partner" data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-alert outlined text type="info" data-tour="area" class="mb-4">
								Per accedere all'area riservata, il partner usa il seguente url: <b>https://partner.azseller.app/</b>
							</v-alert>
							<v-row>
								<v-col cols="12" md="6" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details />
								</v-col>
							</v-row>
						</v-col>

						<v-data-table data-tour="table" :hide-default-header="mobileCards" :class="{ 'table-cards': mobileCards }" :headers="headers" :items="getItems" :options.sync="settings.options" :server-items-length="total" must-sort class="elevation-0" :footer-props="{ 'items-per-page-options': listSize }">
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="partner-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :fields="campiCard(item)">
												<template v-slot:title>
													<span>{{ nomePartner(item) || 'Partner' }}</span>
												</template>
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon v-bind="attrs" v-on="on" color="primary" small data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-primary" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Attivo</span>
													<v-switch v-model="item.active" data-tour="status" color="primary" class="mt-0 pt-0" dense hide-details @change="changeStatus(item)"></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
											<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
											<v-list-item link data-tour="row-primary" @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>
									<v-switch v-model="item.active" data-tour="status" color="primary" class="mt-0" hide-details @change="changeStatus(item)"></v-switch>
										</td>
										<td>{{ item.created_at | moment('DD/MM/YYYY') }}</td>
										<td>{{ item.name }}</td>
										<td>{{ item.lastname }}</td>
										<td>{{ item.email }}</td>
										<td>{{ item.phone }}</td>
										<td>{{ item.fee }}</td>
										<td>{{ item.website }}</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando il partner non potrai più ripristinarlo.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>
					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
			<span v-html="snackbar.text"></span>
			<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
		</v-snackbar>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createPartnerTourSteps, stopAffiliateListTour } from './affiliate-list-tours';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'AffiliatePartner',
	components: {
		TourOverlay,
		KeyValueCard,
	},
	// pagina, righe, ordinamento e ricerca stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createPartnerTourSteps(), { onStop: () => stopAffiliateListTour('affiliate-partner') }) };
	},
	data() {
		return {
			total: 0,
			dialogconfirm: false,
			selectedDeleteItem: null,
			listSize: LIST_SIZE,
			searchfield: '',
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			headers: [
				{ text: '', value: 'actions', sortable: false },
				{ text: 'Status', value: 'active', sortable: true },
				{ text: 'Created', value: 'created_at', sortable: true },
				{ text: 'Nome', value: 'name', sortable: true },
				{ text: 'Cognome', value: 'lastname', sortable: true },
				{ text: 'Email', value: 'email', sortable: true },
				{ text: 'Telefono', value: 'phone', sortable: true },
				{ text: 'Fee', value: 'fee', sortable: true },
				{ text: 'Sito internet', value: 'website', sortable: true },
			],
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
		};
	},
	computed: {
		...mapGetters({
			getItems: 'partners/getItems',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
	},
	created() {
		this.listLoad();
	},
	methods: {
		...mapActions({
			fetchItems: 'partners/asyncFetchData',
			deletePartner: 'partners/deleteItem',
			patchPartner: 'partners/patchItem',
		}),
		async getDataFromApi() {
			const result = await this.fetchItems(this.settings);
			if (result) {
				this.total = result.total;
			}
		},
		// ricerca da tre caratteri; il caricamento lo fa listRouteState
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		createItem() {
			this.$router.push('/affiliate/partner/new');
		},
		editItem(item) {
			if (!item?._id) {
				return;
			}
			this.$router.push(`/affiliate/partner/${item._id}`);
		},
		nomePartner(item) {
			return [item.name, item.lastname].filter(Boolean).join(' ');
		},
		// campi in sola lettura della card da telefono
		campiCard(item) {
			return [
				{ label: 'Creato', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'Email', value: item.email },
				{ label: 'Telefono', value: item.phone },
				{ label: 'Fee', value: item.fee, strong: true },
				{ label: 'Sito internet', value: item.website },
			];
		},
		async changeStatus(item) {
			try {
				await this.patchPartner({ _id: item._id, active: !!item.active });
				this.snackbar.color = 'success';
				this.snackbar.text = 'Status partner aggiornato';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 3000;
			} catch (e) {
				item.active = !item.active;
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore durante aggiornamento status partner';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 4000;
			}
		},
		deleteItem(item) {
			if (!item?._id) {
				return;
			}
			this.selectedDeleteItem = item;
			this.dialogconfirm = true;
		},
		async confirmDelete() {
			if (!this.selectedDeleteItem?._id) {
				this.dialogconfirm = false;
				return;
			}

			try {
				await this.deletePartner({ _id: this.selectedDeleteItem._id });
				await this.getDataFromApi();
				this.dialogconfirm = false;
				this.selectedDeleteItem = null;
				this.snackbar.color = 'success';
				this.snackbar.text = 'Partner eliminato con successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 4000;
			} catch (e) {
				this.snackbar.color = 'error';
				this.snackbar.text = "Errore durante l'eliminazione del partner";
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 4000;
			}
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.$store.dispatch('partners/destroyData');
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.partner-cards,
.partner-cards tr {
	display: block;
	width: 100%;
}
.partner-cards tr,
.partner-cards tr:hover {
	background: transparent !important;
}
.partner-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.partner-cards tr:first-child td {
	padding-top: 12px !important;
}
.partner-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.partner-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
